import { useAuth } from "@/context/auth-context";
import { useGetAccountBalance } from "@/features/transactions/useGetAccountBalance";
import { centsToDollars } from "@/lib/number-conversion/number-conversion.utils";
import { currencyFormatter } from "@/lib/utils";
import { useLoaderData } from "@tanstack/react-router";

type Props = {
	className?: string;
	errorClassName?: string;
	loadingClassName?: string;
};

export const AccountBalanceDisplay: React.FC<Props> = ({
	className,
	loadingClassName,
	errorClassName,
}) => {
	const { user } = useAuth();
	const { location_id } = useLoaderData({ from: "__root__" });
	const {
		data: accountBalance,
		isLoading,
		isError,
	} = useGetAccountBalance({ guestId: user.id, locationId: location_id });

	if (isLoading) {
		return (
			<div className={`${loadingClassName}`}>Loading available balance...</div>
		);
	}

	if (isError) {
		return (
			<div className={`text-utility-red ${errorClassName}`}>
				Failed to load balance
			</div>
		);
	}

	if (!accountBalance) return null;

	return (
		<div className={`text-center ${className}`}>
			{currencyFormatter.format(centsToDollars(accountBalance.balance))}
		</div>
	);
};
